import React from "react";
import { Panel } from "primereact/panel";
import { Timeline } from "primereact/timeline";
import { Alert, Card, Col, Form, Row, Table } from "react-bootstrap";
import { HiDesktopComputer, HiOutlineClipboardList } from "react-icons/hi";
import { useEffect } from "react";
import { getCertificadosMos } from "@helpers/httpRequests/httpRequestMOS/httpRequestMOS";
import { useState } from "react";

import { validarDatosPago } from "@helpers/httpRequests/httpRequestsSAI/httpRequestsSAI";
import { Checkbox } from "@mui/material";
import FormularioNuevaCompra from "@helpers/paymentIntent/FormularioNuevaCompra";
import dashboardRoutesPaths from "@helpers/dashboardRoutesPaths/dashboardRoutesPaths";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { Notificacion } from "@components/general/Alertas/Alertas";
// import { Checkbox } from "primereact/checkbox";

const Certificacion = ({ idCodigoRegion, folioContrato, events, customizedMarker, customizedContent, tab, idPerfil, setBtnCertificadoDisabled, rol, usuarioTitular, derechoMos, esSuscripcion }) => {
	console.log(derechoMos);
	const { t } = useTranslation();
	const [cursosCertificados, setCursosCertificados] = useState(false);

	const [certificados, setCertificados] = useState([]);

	const [excelAplicado, setExcelAplicado] = useState(false);

	const [excelIntermedio, setExcelIntermedio] = useState(false);

	const [pagoCubierto, setPagoCubierto] = useState(0); // 1= 'Pago cubierto'/0 = 'No aplica/ 2 = Pago no cubierto'

	const [datosPago, setDatosPago] = useState({});
	//	state para sacar el promedio del pago

	const [eventoMosPagado, setEventoMosPagado] = useState(false);

	const [pagoCredito, setPagoCredito] = useState({
		aplica: null,
		costoTotal: 0,
		pagado: 0,
		deudaSaldada: null
	});

	useEffect(() => {
		const validarPago = async () => {
			try {

			
				const { data: datosPago1 } = await validarDatosPago(parseInt(folioContrato), idCodigoRegion);

				setDatosPago(datosPago1);

				const { costoTotal, pagado, amortizacionesTotales, pagosContrato } = datosPago1;


				if (amortizacionesTotales > 1) {
					setPagoCredito({
						...pagoCredito,
						aplica: true,
						costoTotal,
						pagado,
					});
				}

				
				pagosContrato.map((amortizacion) => {
					if (amortizacion.conceptoPago === "PAGO POR FINIQUITO"){
						setPagoCredito({
							...pagoCredito,
							deudaSaldada: true
						})
					}
				})

			} catch (error) {
				console.log("Ocurrio un error al consumir la informacion de la api: ", error);
			}
		};

		if(!esSuscripcion) {
			validarPago();
		}

		const verificarCuenta = async () => {
			try {
				const { data, code } = await getCertificadosMos(idPerfil);

				if (Array.isArray(data)) {
					setCertificados(data);

					setCursosCertificados(true);
				} else {
					setCertificados([data]);
					// console.log(data);
				}
			} catch (error) {
				console.log(error);
				setCertificados([]);
			}
		};

		verificarCuenta();
	}, []);

	useEffect(() => {
		//VALIDACION PARA EL PORCENTAJE DEL PAGO
		if (pagoCredito.aplica) {
			const porcentajeCredito = (pagoCredito.pagado * 100) / pagoCredito.costoTotal;

			if (porcentajeCredito >= 85) {
				setPagoCubierto(1);
			} else {
				setPagoCubierto(2);
			}
		} else {
			const { costoTotal, pagado } = datosPago;

			if (costoTotal === pagado) {
				setPagoCubierto(1);
			}
		}
	}, [datosPago]);

	useEffect(() => {
		certificados.map((certificado) => {
			if (certificado.curso === "EI16" || certificado.curso === "EI23") {
				setExcelIntermedio(true);
			}
			if (certificado.curso === "EA16") {
				setExcelAplicado(true);
			}
		});
	}, [certificados]);

	useEffect(() => {
		if (tab === "info") {
			if (pagoCredito.aplica) {
				if (excelAplicado && excelIntermedio) {
					if (pagoCubierto === "Pago cubierto"  || pagoCredito.deudaSaldada || eventoMosPagado) {
						//setRequisitosCubiertos
						setBtnCertificadoDisabled(false);
					}
				} else {
					// Notificacion("info", "Aún no cubres todos los requisitos para agendar tu examen de certificación")
					setBtnCertificadoDisabled(true);
				}
			} else {
				if (excelAplicado && excelIntermedio) {
					if (pagoCubierto === "Pago cubierto"  || pagoCredito.deudaSaldada || eventoMosPagado) {
						//setRequisitosCubiertos
						setBtnCertificadoDisabled(false);
					}
				} else {
					setBtnCertificadoDisabled(true);

					Notificacion("info", `Aún no cubres todos los requisitos para agendar tu examen de certificación`)
				}
			}
		}
	}, [tab]);

	return (
		<>
			<Row className="mt-5">
				<Col className="col-12 col-lg-6 col-6">
					<iframe
						className="ratio ratio-16x9"
						width="100%"
						height="100%"
						src="https://player.vimeo.com/video/805643035?h=c2b119362d&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
						allow="autoplay; fullscreen; picture-in-picture"
						allowFullScreen
						title="Certificación MOS video"
					/>
				</Col>

				<Col className="col-12 col-lg-6 col-6">
					<Card>
						<Card.Header>
							<h4>{t("requisitosMOS.titleMOS")}</h4>
						</Card.Header>

						<Card.Body>
							<p>
								{t("requisitosMOS.descripcionMOS")}
							</p>
						</Card.Body>
					</Card>
				</Col>
			</Row>

			<Row className="mt-5 mb-5">
				<Col className="col-12 col-lg-7 mt-4 mt-lg-0">
					<h4>
						<HiOutlineClipboardList /> Requisitos
					</h4>

					<Table borderless>
						<thead>
							<tr>
								<th>{t("requisitosMOS.requirements.description")}</th>
								<th></th>
								<th></th>
							</tr>
						</thead>

						<tbody>
							<tr>
								<td>- {t("requisitosMOS.requirements.intermediateExcel")}</td>
								<td></td>
								<td>
									{/* <Checkbox checked={excelIntermedio ? true : false} /> */}
									<Form.Check type="checkbox" checked={excelIntermedio}/>
								</td>
							</tr>

							<tr>
								<td>- {t("requisitosMOS.requirements.advancedExcel")}</td>
								<td></td>
								<td>
									{/* <Checkbox checked={excelAplicado ? true : false} /> */}
									<Form.Check type="checkbox" checked={excelAplicado}/>
								</td>
							</tr>

							{/* {esSuscripcion ? (
								<tr>
									<td>- {t("requisitosMOS.requirements.extraPayment")}</td>
									<td></td>
									<td>
										<span className={(pagoCubierto === 1 && derechoMos) ? "text-success" : "text-danger"}>{(pagoCubierto === 1 && derechoMos === 1) ? "Pago cubierto" : "Pago no cubierto"}</span>
									</td>
								</tr>
							) : (
								<tr>
									<td>- {t("requisitosMOS.warningMessage")}</td>
									<td></td>
									<td>
										{pagoCredito ? (
											<span className={pagoCubierto === 1 ? "text-success" : "text-danger"}>{pagoCubierto === 1 ? t("requisitosMOS.paymentStatus") : t("requisitosMOS.paymentStatus")}</span>
										) : (
											<span className={pagoCubierto === 0 && "text-success"}>{pagoCubierto}</span>
										)}
									</td>
								</tr>
							)} */}
							{!esSuscripcion && (
								<tr>
									<td>- {t("requisitosMOS.warningMessage")}</td>
									<td></td>
									<td>
										{pagoCredito ? (
											<span className={pagoCubierto === 1 ? "text-success" : "text-danger"}>{pagoCubierto === 1 ? t("requisitosMOS.paymentStatus") : t("requisitosMOS.paymentStatus")}</span>
										) : (
											<span className={pagoCubierto === 0 && "text-success"}>{pagoCubierto}</span>
										)}
									</td>
								</tr>
							)}

							<tr>
								<td>-  {t("requisitosMOS.requirements.mosLessons")}</td>
								<td></td>
							</tr>
						</tbody>
					</Table>
				</Col>

				<Col className="col-12 col-lg-5 mt-4 mt-lg-0">
					<h4>
						<HiDesktopComputer /> Requisitos del sistema
					</h4>

					<ul className="mt-4">
						<li>{t("requisitosMOS.requirements.minimumOS")}</li>
						<li>{t("requisitosMOS.requirements.stableInternet")}</li>
					</ul>
				</Col>
			</Row>

			{/* validar y mostrar el form de pago para agendar examen  */}
			<Row className="justify-content-center mb-5">
				<Col className="col-12 col-lg-6">
					{derechoMos ? (
						<div className="text-center">
							<FontAwesomeIcon icon={faCheck} color="green" size="5x" className="mb-4"/>
							<h2>{t("extrasCertificacionMos.title")}</h2>
							<small>{t("extrasCertificacionMos.subtitle")}</small>
						</div>
					): (
						<FormularioNuevaCompra
						idPerfil={idPerfil}
						imgProducto={require("@assets/images/click.png")}
						precioProducto={2000 * 100}
						precioProductoUSD={2000 * 100}
						nombreProducto={"Compra de Certificacion MOS | 1 persona"}
						compraExterna={false}
						compraLectura={false}
						compraKueski={false}
						folioContrato={folioContrato}
						// codigoAplicado={codigoAplicado}
						// precios={precios}
						// valueRadioButton={valueRadioButton}
						msiEnabled={false}
						esRenovacion={false}
						esCompraExtraMos={true}
						successUrl={`${dashboardRoutesPaths.default}`}
					/>
					)}
				</Col>
			</Row>


			<Row>
				<Col className="text-center">
					<Alert variant="danger">{t("requisitosMOS.noShowPolicy")}</Alert>
				</Col>
			</Row>

			<Row className="mt-5 mb-5">
				<Col>
					<Timeline value={events} align="alternate" className="customized-timeline" marker={customizedMarker} content={customizedContent} />
				</Col>
			</Row>
		</>
	);
};

export default Certificacion;
